/* eslint-disable max-classes-per-file */
/* eslint-disable camelcase */
import { loginService, APIBase } from '@agro1desenvolvimento/apis-js-package';
import { ENV } from '../../utilities/constants';

class LaboratorioAPI extends APIBase {
  constructor() {
    super();

    let baseURL = 'https://homologacao-integrations.aqila.com.br';
    if (ENV === 'production') {
      baseURL = 'https://integrations.aqila.com.br';
    }

    this.initialize({ baseURL });

    this.request.interceptors.request.use((request) => {
      const headers = loginService.requestHeaders();
      delete headers['X-Scope'];
      request.headers = {
        ...headers,
        ...request.headers,
        'X-Scope': 'sementes',
      };
      return request;
    });
  }
}

const laboratorioAPI = new LaboratorioAPI();

interface APIGrau {
  id: string;
  descricao: string;
  valor_correspondente: number;
  tecla_correspondente: string;
  ordem: number;
  obriga_dano: boolean;
  integration_id: string;
  integration_status: number;
  deleted: string | null;
  created_at: string;
  updated_at: string;
}

interface APIGrausResponse {
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
  data: APIGrau[];
}

export interface Grau {
  id: string;
  descricao: string;
  valor: number;
  tecla: string;
  ordem: number;
  obrigaDanoIntenso: boolean;
}

function convertAPIGrauToInternal(apiData: APIGrau): Grau {
  return {
    id: apiData.id,
    descricao: apiData.descricao,
    valor: apiData.valor_correspondente,
    tecla: apiData.tecla_correspondente,
    ordem: apiData.ordem,
    obrigaDanoIntenso: apiData.obriga_dano === true,
  };
}

export interface DanoTecla {
  tipo: string;
  label: string;
  tecla?: string;
}

interface APIResultado {
  id: string;
  descricao: string;
  tipo_dano: string;
  dano_inicial: number;
  dan_final: number;
  ordem: number;
  lista_id_grau: string;
  filtrar_intensos: boolean;
  informar_assistente: boolean;
  arredondar_vigor_viabilidade: 'S' | 'N';
  integration_id: string;
  integration_status: number;
  deleted: string | null;
  created_at: string;
  updated_at: string;
}

interface APIResultadosResponse {
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
  data: APIResultado[];
}

export interface Resultado {
  id: string;
  descricao: string;
  tipoDano: string;
  danoInicial: number;
  danoFinal: number;
  ordem: number;
  listaIdGrau: string;
  filtrarIntensos: boolean;
  informarAssistente: boolean;
  arredondarVigorViabilidade: boolean;
}

export interface ApiDanoResponse {
  total: number
  data: DanoConfigData[]
  page: number
  per_page: number
  total_pages: number
}

export interface DanoConfigData {
  danos_configurados: DanoConfigurado[]
  id: string
  updated_at: string
  integration_id: string
  model: string
  integration_status: number
  deleted: string | null
  created_at: string
}

export interface DanoConfigurado {
  id: string
  descricao: string
  tecla_atalho: string
}

function convertAPIResultadoToInternal(apiData: APIResultado): Resultado {
  return {
    id: apiData.id,
    descricao: apiData.descricao,
    tipoDano: apiData.tipo_dano,
    danoInicial: apiData.dano_inicial,
    danoFinal: apiData.dan_final,
    ordem: apiData.ordem,
    listaIdGrau: apiData.lista_id_grau,
    filtrarIntensos: apiData.filtrar_intensos,
    informarAssistente: apiData.informar_assistente,
    arredondarVigorViabilidade: apiData.arredondar_vigor_viabilidade === 'S',
  };
}

class TetrazolioConfiguracoesService {
  async listGraus(page = 1): Promise<{ graus: Grau[]; totalPages: number }> {
    const response = await laboratorioAPI.get<APIGrausResponse>(
      '/api/v1/agro1/laboratorio/tz_graus',
      { params: { page } },
    );

    const graus = response.data.data
      .map(convertAPIGrauToInternal)
      .sort((a, b) => a.ordem - b.ordem);

    return {
      graus,
      totalPages: response.data.total_pages,
    };
  }

  async listDanos(page = 1): Promise<{ danos: DanoTecla[]; totalPages: number }> {
    const { data } = await laboratorioAPI.get<ApiDanoResponse>(
      '/api/v1/agro1/laboratorio/tz_danos',
      { params: { page } },
    );

    const { data: responseData } = data;

    const { danos_configurados: danosConfigurados } = responseData[0];

    const allDanos: DanoTecla[] = danosConfigurados.map((dano) => ({
      label: dano.descricao,
      tecla: dano.tecla_atalho,
      tipo: dano.id,
    }));

    return {
      danos: allDanos,
      totalPages: data.total_pages,
    };
  }

  async listResultados(page = 1): Promise<{ resultados: Resultado[]; totalPages: number }> {
    const response = await laboratorioAPI.get<APIResultadosResponse>(
      '/api/v1/agro1/laboratorio/tz_resultados',
      { params: { page } },
    );

    const resultados = response.data.data.map(convertAPIResultadoToInternal);

    return {
      resultados,
      totalPages: response.data.total_pages,
    };
  }
}

export default new TetrazolioConfiguracoesService();
